module.exports = __webpack_public_path__ + "static/img/m_index_06.8ab2751c.jpg";